// extracted by mini-css-extract-plugin
var _1 = "b0lXm";
export { _1 as "container" }
